import React, { useEffect, useState } from 'react';
import { KitCategories, MediaKitModel, MediaKitSettingModel } from '../submission_kits/components/KitModels';
import { useMedia } from 'react-use';
import { showToast } from '../shared/Toast';
import mediaKitService from '../services/MediaKitService';
import CustomUppyUploader from '../submission_kits/components/CustomUppyUploader';
import kitDocumentService from '../services/KitDocumentService';
import FilePreviewer from '../submission_kits/components/FilePreviewer';
import ConfirmationDialog from '../shared/ConfirmationDialog';
import { ComputerDesktopIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/solid';

export interface MediaKitDocumentListProps {
  mediaKitModel: MediaKitModel;
  kit_documents: any;
  mediaSetting: MediaKitSettingModel;
  from: string;
  refreshMedias: () => void;
  removeMediaHandler: (kit_document: any) => Promise<boolean>;
}
export default function MediaKitDocumentList({
  from,
  mediaKitModel,
  kit_documents,
  mediaSetting,
  refreshMedias,
  removeMediaHandler,
}: MediaKitDocumentListProps) {
  const [isAddMedia, setIsAddMedia] = useState<boolean>(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [kitDocumentDelete, setKitDocumentDelete] = useState(null);
  const [mediaSize, setMediaSize] = useState(from === 'media_kit'?'xl':'md');

  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  
  const handleDeleteMediaClicked = async () => {
    if (kitDocumentDelete == null && !kitDocumentDelete.id) return;
    try {
      console.log("Delete file ")
      await removeMediaHandler(kitDocumentDelete);
      hideDeleteConfirm();
    } catch (error) {
      showToast('Error in removing media', 'danger');
    }
  };
  const hideDeleteConfirm = () => {
    console.log('Delete set null');
    setKitDocumentDelete(null);
    console.log('Delete set null done');
    setShowDeleteConfirmationModal(false);
  };

  const removeMediaClickHandler = async (event:any, kit_document: any, index: number) => {
    try {
      event.preventDefault();
      setKitDocumentDelete(kit_document);
      setShowDeleteConfirmationModal(true);
    } catch (error) {
      showToast('Error in removing media', 'danger');
    }
  };

  const handleDragStart = (e: any, kit_document: any) => {
    // e.preventDefault();
    console.log('handleDragStart');
    if (from === 'submission_kit') {
      console.log('handleDragStart submission_kit');
      const jsonItem = JSON.stringify(kit_document);
      e.dataTransfer.setData('application/json', jsonItem);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    console.log('handleDragOver');
    event.preventDefault();
  };

  useEffect(() => {
    console.log('mediaSize:', mediaSize);
  }, [mediaSize])

  return (
    <div className="scrollable-content overflow-y-auto justify-items-center">
      <div className="flex w-full flex-col p-1">
        <div className="flex flex-1 flex-col pt-1 pb-2 px-2">
          <div className="w-full">
            <div className="gap-2 flex flex-row justify-end">
              <div className="float-right flex flex-row">
                <div
                  className="float-right flex cursor-pointer items-center"
                  style={{}}
                  onClick={() => {
                    setMediaSize('xl');
                  }}
                >
                  <ComputerDesktopIcon className="h-8 w-8" aria-hidden="true" />
                </div>
                <div
                  className="float-right flex cursor-pointer items-center pl-2"
                  style={{}}
                  onClick={() => {
                    setMediaSize('lg');
                  }}
                >
                  <ComputerDesktopIcon className="h-6 w-6" aria-hidden="true" />
                </div>
                <div
                  className="float-right flex cursor-pointer items-center pl-2"
                  style={{}}
                  onClick={() => {
                    setMediaSize('md');
                  }}
                >
                  <ComputerDesktopIcon className="h-4 w-4" aria-hidden="true" />
                </div>
              </div>
              <div className="float-right flex">
                {(from === 'media_kit' || from === 'submission_kit') && (
                  <>
                    <div
                      id={'addmedia_mk_text_id'}
                      onClick={() => {
                        setIsAddMedia(true);
                      }}
                      className="px-2 py-2 text-base leading-6 font-medium items-center mr-2 text-blue-500 cursor-pointer"
                    >
                      Add media
                    </div>

                    <div
                      id={'addmedia_mk_btn_id'}
                      className="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500  cursor-pointer"
                      onClick={() => {
                        setIsAddMedia(true);
                      }}
                    >
                      <svg
                        className="h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        ></path>
                      </svg>
                    </div>
                  </>
                )}
              </div>
              <div
                id={'refresh_mk_btn_id'}
                className="float-right flex items-center cursor-pointer pl-2"
                onClick={() => {
                  refreshMedias();
                }}
              >
                <a className="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <svg
                    className="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M12 18.24c-3.456 0 -6.24 -2.784 -6.24 -6.24 0 -1.536 0.576 -2.976 1.584 -4.128l0.72 0.624C7.2 9.456 6.72 10.704 6.72 12c0 2.928 2.352 5.28 5.28 5.28 0.768 0 1.488 -0.144 2.208 -0.48l0.384 0.864Q13.368 18.24 12 18.24" />
                    <path d="m16.656 16.176 -0.72 -0.624c0.864 -0.96 1.344 -2.208 1.344 -3.504 0 -2.928 -2.352 -5.28 -5.28 -5.28 -0.768 0 -1.488 0.144 -2.208 0.48l-0.384 -0.864q1.224 -0.576 2.592 -0.576c3.456 0 6.24 2.784 6.24 6.24 0 1.488 -0.576 2.976 -1.584 4.128" />
                    <path d="M8.64 11.52h-0.96v-2.88h-2.88v-0.96h3.84z" />
                    <path d="M19.2 16.32h-3.84v-3.84h0.96v2.88h2.88z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        {isAddMedia && (
          <div className="">
            <div className="border-b flex flex-col gap-4 p-2">
              <CustomUppyUploader
                backendUrl={'/'}
                mediaSetting={mediaSetting}
                handleCloseUploader={() => {
                  setIsAddMedia(false);
                  refreshMedias();
                }}
                filesUploaded={async (fileUppy: any) => {
                  await kitDocumentService.createKitDocument(
                    fileUppy,
                    KitCategories.media_kit_cat,
                    mediaKitModel.uuid
                  );
                }}
              />
            </div>
          </div>
        )}
        <div
          className={
            (is400_639Screen ? 'px-16 ' : 'p-0 ') +
            // ' grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'
            ' flex flex-row flex-wrap'
          }
          id={'medialist_mk_id'}
        >
          {kit_documents.map((kit_document, index) => {
            return (
              <div
                key={index}
                className={'flex flex-col bg-white shadow-lg border-2 mr-1 mb-1'}
                draggable="true"
                style={{
                  width:
                    mediaSize == 'xl'
                      ? '250px'
                      : mediaSize == 'lg'
                      ? '150px'
                      : mediaSize == 'md'
                      ? '90px'
                      : '45px',
                }}
                onDragStart={(e) => handleDragStart(e, kit_document)}
                onDragOver={handleDragOver}
              >
                <a target={'_blank'}>
                  <div className="flex flex-1 flex-col h-full">
                    <FilePreviewer
                      file_url={kit_document.file_url}
                      file_name={kit_document.file_name}
                      file_content_type={kit_document.file_content_type}
                    />
                  </div>
                </a>
                {from === 'media_kit' && (
                  <div className="px-2 py-1 flex justify-center items-center">
                    <div
                      id={'removemedia_mk_btn_id'}
                      onClick={async (event: any) => {
                        await removeMediaClickHandler(event, kit_document, index);
                      }}
                      className="text-xs leading-6 font-medium items-center text-blue-500 cursor-pointer"
                    >
                      Remove
                    </div>
                  </div>
                )}
                
              </div>
            );
          })}
        </div>
      </div>
      <ConfirmationDialog
        title="Delete media?"
        description="Are you sure you want to delete this media? This media and its details will be permanently deleted."
        onCancelLabel="Cancel"
        onCancelAction={() => hideDeleteConfirm()}
        onConfirmLabel="Confirm"
        onConfirmAction={handleDeleteMediaClicked}
        isOpen={showDeleteConfirmationModal}
        onClose={() => hideDeleteConfirm()}
        icon={
          <div className="rounded-full p-3 bg-red-200">
            <ExclamationTriangleIcon className="w-6 h-6 text-red-500 " />
          </div>
        }
      />
    </div>
  );
}
